import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { LANGUAGE } from "libs/utils/constants";

export interface LanguageState {
  language: LANGUAGE;
  appLoaded: boolean
}

const initialState: LanguageState = {
    language: LANGUAGE.ENGLISH,
    appLoaded: false
};

export const languageSlice = createSlice({
  name: "language",
  initialState,
  reducers: {
    setLanguage: (state, action: PayloadAction<LANGUAGE>) => {
      state.language = action.payload;
    },
    setAppLoaded: (state) => {
      state.appLoaded = true;
    },
  },
});

export const { setLanguage, setAppLoaded } = languageSlice.actions;

export default languageSlice.reducer;
